import defaultTheme from './default';

// unsets some values set in the widgetBootstrap template
const styles = `#root { height: auto !important; }`;

export default function (): string {
  return `${styles}${defaultTheme}`;
}
